import { UnstyledButton } from '@mantine/core';
// components
import { PopoverButton } from '@newo/ui-kit';
// icons
import { CopyIcon, Trash2 } from 'lucide-react';
// utils
import { TSkill, TSkillData } from '@newo/api/gateway';
import { cn } from '@/utils';
import AddSkillForm from '@/modules/Designer/components/Skills/components/AddSkillForm';

interface SkillItemProps {
    skill: TSkill;
    isSelected: boolean;
    onSelect: (skillId: string) => void;
    onDelete: (skill: TSkill) => void;
    onUpdate: (data: TSkillData) => Promise<unknown>;
}

const SkillItem = ({
    skill,
    isSelected,
    onSelect,
    onDelete,
    onUpdate
}: SkillItemProps) => {
    const handleDelete = () => {
        onDelete(skill);
    };

    const handleSelect = () => {
        onSelect(skill.id);
    };

    return (
        <div
            className={cn(
                'group overflow-hidden flex gap-2 items-center cursor-pointer hover:bg-gray-1 px-3',
                {
                    'bg-gray-2': isSelected
                }
            )}
        >
            <UnstyledButton
                className="w-[25ch] font-semibold flex-1 text-xs whitespace-nowrap overflow-hidden overflow-ellipsis py-0.75"
                onClick={handleSelect}
            >
                {skill.idn}
            </UnstyledButton>
            <PopoverButton
                title="Duplicate Skill"
                trigger={
                    <CopyIcon className="text-xs text-gray-6 invisible group-hover:visible" />
                }
            >
                {(close) => (
                    <AddSkillForm
                        skill={skill}
                        onCancel={close}
                        onSubmit={onUpdate}
                    />
                )}
            </PopoverButton>
            <UnstyledButton
                className="invisible group-hover:visible"
                title="Delete Skill"
                onClick={handleDelete}
            >
                <Trash2 className="text-xs text-gray-6" />
            </UnstyledButton>
        </div>
    );
};

export default SkillItem;
